<template>
  <div class="mobilebar-profile">
    <nav class="menu">
      <ul>
        <li v-for="(item, index) in mobileSidebarList" :key="index">
          <router-link
            :to="item.link"
            custom
            v-slot="{ href, navigate, isActive }"
          >
            <a
              :href="href"
              class="menu-link"
              :class="{ active: isActive }"
              @click.prevent="onMenuClick(item, navigate)"
            >
              <img :src="item.icon" />
            </a>
          </router-link>
        </li>
      </ul>
    </nav>
    <BuyASubscriptionWarningModal ref="subscriptionWarningModal" />
  </div>
</template>

<script>
import { defineComponent, computed, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { sidebarList } from "@/models/sidebar";
import BuyASubscriptionWarningModal from "@/components/Modals/BuyASubscriptionWarningModal.vue";

export default defineComponent({
  name: "MobileBar",
  components: { BuyASubscriptionWarningModal },
  setup() {
    const router = useRouter();
    const store = useStore();
    const currentUser = computed(() => store.state.user.user);

    const subscriptionWarningModal = ref(null);

    const hiddenTitles = [
      "Профиль",
      "Отзывы",
      "Корзина",
      "Поддержка",
      "Подписка",
    ];

    const restrictedTitles = ["Сообщения", "Друзья"];

    const mobileSidebarList = computed(() =>
      sidebarList.value.filter((item) => !hiddenTitles.includes(item.title))
    );

    const isLimitedUser = computed(() => {
      const membership = currentUser?.value?.name_membership;
      return !membership || membership === "Free";
    });

    const onMenuClick = (item, navigate) => {
      if (isLimitedUser?.value && restrictedTitles.includes(item.title)) {
        subscriptionWarningModal?.value?.openModal();
        return;
      }
      navigate();
    };

    return {
      sidebarList,
      mobileSidebarList,
      router,
      subscriptionWarningModal,
      onMenuClick,
    };
  },
});
</script>

<style lang="scss">
@import "@/assets/styles/profile/mobilebar.scss";
</style>
